export default {
  // Page titles
  pageTitle: 'Game Activity Manager',
  myActivities: 'My Game Activities',
  searchPlaceholder: 'Search game activities',
  addNew: 'New',
  noActivities: 'No game activities yet',

  // Action menu
  settings: 'Settings',
  duplicate: 'Duplicate',
  copySuffix: ' (Copy)',
  deleteAction: 'Delete',

  // Modal titles
  createActivity: 'Create Game Activity',
  updateActivity: 'Update Game Activity Settings',

  // Form fields
  activityName: 'Activity Name',
  activityNamePlaceholder: 'New Game Activity',
  questionType: 'Question Type',
  gameSettingsEntry: 'Game Settings',
  enableEntry: 'Enable Entry',
  disableEntryToEditSettings: 'To edit game settings, please disable "Enable Entry" first',
  settingsLockedWarning: 'Activity is published and open for entry, cannot edit game settings',

  // Question types
  recognition: 'Recognition',
  trueFalse: 'True/False',
  multiChoice: 'Single Choice',
  aiGenerated: 'Custom',

  // Buttons
  cancel: 'Cancel',
  confirm: 'Confirm',
  publish: 'Publish Short URL',
  gamePreview: 'Game Preview',

  // Messages
  activityCreated: 'Activity created successfully',
  activityDeleted: 'Activity deleted successfully',
  gameSettingsComingSoon: 'Game settings feature coming soon',
  pushConfirmMessage: 'After pushing, a new activity will be created in the Game Activity Manager. Do you want to proceed?',

  // Error messages
  activityNameRequired: 'Activity name is required',
  activityNameTooLong: 'Activity name cannot exceed 20 characters',

  // Game selection modal
  selectGameType: 'Select Game Type',

  // Game card names
  moleGameCard: 'Mole Game',
  starGameCard: 'Star Picking',
  rocketGameCard: 'Rocket Launch',
  snakeGameCard: 'Vocabulary Snake',
  mazeGameCard: 'Maze',
  aiGameCard: 'Custom Game',

  // Game settings panel
  playerCount: 'Player Count',
  person: 'Player',
  defaultTemplate: 'Default Template',
  moleGame: 'Mole Game',
  starGame: 'Star Game',
  snakeGame: 'Vocabulary Snake',
  mazeGame: 'Maze',
  rocketGame: 'Rocket Launch',
  aiGame: 'Custom Game',
  allowTemplateChange: 'Allow Template Change',
  switchGame: 'Switch Game',
  gameParameters: 'Game Parameters',
  gameParametersNote: 'Game parameters will be set after selecting a template',

  // Game parameters form
  topic: 'Topic',
  topicWithActivityName: 'Topic (Activity Name)',
  inputTopic: 'Enter topic',
  correctItems: 'Correct Items',
  correctItemsPlaceholder: 'Enter correct vocabulary, separated by line breaks or commas (,), press Enter to confirm',
  errorItems: 'Error Items',
  errorItemsPlaceholder: 'Enter error vocabulary, separated by line breaks or commas (,), press Enter to confirm',
  gameDuration: 'Game Duration',
  second: 'Second',
  moleSpeed: 'Mole Speed',
  gameSpeed: 'Game Speed',
  speedSlow: 'Slow',
  speedMedium: 'Medium',
  speedFast: 'Fast',
  speedVeryFast: 'Very Fast',
  backgroundSetting: 'Background Setting',
  forest: 'Forest',
  desert: 'Desert',
  ocean: 'Ocean',

  // Validation messages
  wordExists: 'This item already exists',
  maxVocabulary: 'Maximum 20 correct items',
  maxErrorVocabulary: 'Maximum 20 error items',
  unsubmittedWarning: 'Unsubmitted words found in the input field. Please confirm and press Enter before proceeding!',

  // AI Custom Game
  customGameCode: 'Custom Game Code',
  customGameCodePlaceholder: 'Enter HTML/CSS/JavaScript. HTML tags can be entered in simple version or full version with style and script tags.',

  // Delete confirmation
  deleteConfirmTitle: 'Delete Activity',
  deleteConfirmMessage: 'Are you sure you want to delete this activity? This action cannot be undone.',
  delete: 'Delete',
  deleting: 'Deleting...',

  // Preview mode
  previewMode: 'Preview Mode',
  previewRefreshWarning: 'Hint: Preview data will be cleared after page refresh and will enter default demo mode. To preview again, please reopen from settings.',

  // Status indicators
  statusOpen: 'Open',

  // Short URL related messages
  shortUrlCopied: 'Short URL copied to clipboard',
  copyFailed: 'Copy failed, please copy manually',
  shortUrlAutoUpdated: 'Short URL has been automatically updated, please share it again with students',
  shortUrlGenerated: 'Short URL generated, please click Confirm to save the activity',
  shortUrlPublished: 'Short URL published successfully',
  shortUrlPublishFailed: 'Failed to publish short URL, please try again later',

  // Activity operation messages
  activityCreateFailed: 'Failed to create activity, please try again later',
  activityUpdateFailed: 'Failed to update activity, please try again later',
  activityUpdated: 'Activity updated successfully',
  activityDeleteFailed: 'Failed to delete activity, please try again later',
  activityDuplicated: 'Activity duplicated successfully',
  activityDuplicateFailed: 'Failed to duplicate activity, please try again later',

  // Student info
  enterStudentInfo: 'Enter Student Information',
  selectStudent: 'Select Student',
  studentName: 'Name',
  studentNamePlaceholder: 'Enter your name',
  studentSeatNumber: 'Seat Number (Optional)',
  seatNumberPlaceholder: 'e.g. 5',
  studentNameRequired: 'Please enter your name',
  seatNumberRequired: 'Please enter seat number',
  studentNameTooLong: 'Name cannot exceed 20 characters',
  seatNumberInvalid: 'Seat number must be 1-3 digits',
  nameAlreadyUsed: 'This name is already used by the other player',
  seatNumberAlreadyUsed: 'This seat number is already used by the other player',
  confirmStudentInfo: 'Start Game',

  // HT Roster Import Feature
  useHiTeachRoster: 'Use HT to Import Roster',
  requestCurrentRoster: 'Request Current Roster',
  studentList: 'Student List',
  students: 'Students',
  seatNo: 'Seat No.',
  rosterEmptyHint: 'No roster data available. Please click "Request Current Roster" to fetch from HiTeach',
  rosterNotFound: 'HiTeach roster not found. Please ensure you opened from HiTeach',
  rosterLoadError: 'Error occurred while loading roster',
  rosterSourceOnlyInHT: 'Roster source can only be set within HT',
  confirmRefreshRoster: 'Are you sure you want to request the current roster from HiTeach?',
  requestingRoster: 'Requesting roster...',
  refreshRosterError: 'Failed to request roster. Please try again later',
  refreshRosterTimeout: 'Request roster timeout. Please try again later',
  rosterRefreshSuccess: 'Roster updated ({count} students)',
  rosterStillEmpty: 'Roster is still empty. Please verify student roster is set in HiTeach',
  clickToRefresh: 'Click to Request',

  // Activity loading
  activityLoadSuccess: 'Activity loaded successfully',
  loadActivitySuccess: 'Activity loaded successfully',
  activityNotOpen: 'This activity is not open yet',
  activityLoadFailed: 'Failed to load activity',
  loadActivityFailed: 'Failed to load activity, using demo mode',

  // Score submission
  scoreSubmitted: 'Score submitted successfully',
  scoreSubmitFailed: 'Failed to submit score, please try again later',

  // Scores panel
  viewScores: 'View Scores',
  scoresTitle: 'Scores',
  loadingScores: 'Loading scores...',
  noScoresYet: 'No scores yet',
  totalSubmissions: 'Total Submissions',
  averageScore: 'Average Score',
  highestScore: 'Highest Score',
  rank: 'Rank',
  seatNumber: 'Seat No.',
  score: 'Score',
  correctCount: 'Correct',
  wrongCount: 'Wrong',
  submitTime: 'Submit Time',
  prevPage: 'Previous',
  nextPage: 'Next',
  loadScoresFailed: 'Failed to load scores, please try again later',

  // HT exclusive features (webview + HT roster)
  awesome: 'Awesome',
  sendScores: 'Send Scores',
  clickToAwesome: 'Click to give praise',
  noSeatNumber: 'Student has no seat number',
  awesomeSent: 'Praise sent',
  awesomeFailed: 'Failed to send praise',
  noScoresToSend: 'No scores to send',
  noValidScores: 'No valid scores (seat number required)',
  scoresSent: 'Scores sent',
  sendScoresFailed: 'Failed to send scores',

  // Game template switching messages
  templateSwitchedNoScore: 'Template switched detected. For fairness, scores will not be submitted!',

  // User guide messages - Step 1, 2, 3 & 4
  gameActGuide: {
    step1: {
      main: 'Start Here',
      sub: 'Create your first game activity'
    },
    step2: {
      hint1: 'Step 1: Fill in game settings (questions, answers, game template, etc.)',
      hint2: 'Step 2: Click "Game Preview" to confirm',
      hint3: 'Step 3: Click the "Back" button in the upper left corner when done',
      backButton: 'Click here to return when done'
    },
    step3: {
      confirmButton: 'Click "Confirm" to create activity'
    },
    step4: {
      publishButton: 'Click "Publish Short URL" to share with students'
    }
  },

  // Security check messages
  securityCheck: {
    title: '⚠️ Security Check Found Issues',
    errorTitle: '🔴 Critical Issues',
    warningTitle: '⚠️ Warnings',
    suggestionTitle: 'Suggestions',
    suggestion1: 'Avoid using onclick, onerror and other inline event handler attributes',
    suggestion2: 'Use addEventListener instead for event binding',
    suggestion3: 'Avoid using nested iframe, object, embed tags',
    continuePreview: 'Preview will continue, but it is recommended to fix these issues for best practices.'
  },

  // Roster uncheck confirmation (non-WebView)
  rosterUncheckConfirmTitle: 'Stop Using HT Roster',
  rosterUncheckConfirmMessage: 'If you uncheck this option and save, the HT roster loaded for this activity will be cleared. Afterwards, the roster can only be fetched again from within HiTeach.',

  // Clear settings
  clearSettings: 'Clear Settings',
  confirmClearSettings: 'Are you sure you want to clear all settings?',
  settingsCleared: 'Settings cleared',

  // Required field validation
  topicRequired: 'Please enter a topic',
  correctItemsRequired: 'Please add at least one correct answer',
  errorItemsRequired: 'Please add at least one wrong answer',
  questionListRequired: 'Please add at least one question',
  requiredFieldsMissing: 'The following fields are required:',

  // Activity usage display
  activityUsage: 'Activity Usage',
  usageFormat: '{current} / {max}',

  // Activity limit exceeded
  activityLimitExceeded: 'Activity limit reached ({maxLimit} activities). Please delete some activities and try again!'
};
